import React from 'react'

import Empty from './empty'
import GovPersonnelActions from './gov-actions'
import GovPersonnelList from './gov-personnel-list'
import { active } from '../../../container'
import './grouped-registrations.css'

const PersonnelOrEmpty = ({ gov_registration, personnel }) =>
  gov_registration.gov_person_registrations.length > 0 ? (
    <GovPersonnelList gov_registration={gov_registration} />
  ) : (
    <Empty personnel={personnel} gov_registration={gov_registration} />
  )

const MaybeActionButtons = ({ gov_registration, personnel }) =>
  active(personnel) ? <GovPersonnelActions record={{ gov_registration, personnel }} /> : null

const GroupedRegistrations = ({ gov_registration, personnel }) => (
  <div className="grouped-registrations--wrapper">
    <PersonnelOrEmpty gov_registration={gov_registration} personnel={personnel} />
    <MaybeActionButtons gov_registration={gov_registration} personnel={personnel} />
  </div>
)

export default GroupedRegistrations



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/views/grouped-registrations.jsx